import { acrossOf, alongOf, at, headingOf, trailAt, wayOf } from '../../data/full/path-layout';
import type { PlayerId, SimState, Vec2 } from '../state';

const LOOKAHEAD = 160;

// It reads the state only: same seed, same festival.
export function festivalBotMove(state: SimState, playerId: PlayerId): Vec2 | undefined {
  const { festival } = state;
  const player = state.players.find((candidate) => candidate.id === playerId);
  if (festival === undefined || player === undefined) {
    return undefined;
  }
  if (festival.phase === 'sunrise') {
    const exit = festival.exits[0];
    return exit === undefined
      ? undefined
      : headingTo({ x: exit.x - player.x, y: exit.y - player.y }, exit.radius / 3);
  }
  if (festival.phase === 'path' && festival.taken !== undefined) {
    const way = wayOf(state.arena);
    const heading = headingOf(festival.taken.side);
    const ahead = alongOf(way, player) + heading * LOOKAHEAD;
    return headingTo(at(way, heading * LOOKAHEAD, trailAt(way, ahead) - acrossOf(way, player)), 0);
  }
  return undefined;
}

function headingTo(to: Vec2, stopWithin: number): Vec2 {
  const distance = Math.sqrt(to.x * to.x + to.y * to.y);
  return distance <= stopWithin ? { x: 0, y: 0 } : { x: to.x / distance, y: to.y / distance };
}
